import React, { useState } from 'react';
import { Search, Plus, X, Calendar, Clock, Trash2, ExternalLink, Circle, CheckCircle2 } from 'lucide-react';

const TasksPage = ({ tasks, setTasks }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [showSearch, setShowSearch] = useState(false);

  // Defaults
  const today = new Date().toISOString().split('T')[0];
  const now = new Date().toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' });

  const [input, setInput] = useState('');
  const [date, setDate] = useState(today);
  const [time, setTime] = useState(now);
  const [link, setLink] = useState('');

  const addTask = () => {
    if (!input.trim()) return;
    const newTask = { id: Date.now(), text: input, date, time, link, completed: false };
    setTasks([newTask, ...tasks]);
    setInput(''); setLink(''); setDate(today); setTime(now);
    setIsModalOpen(false);
  };

  const filtered = tasks.filter(t => t.text.toLowerCase().includes(searchTerm.toLowerCase()));
  const pending = filtered.filter(t => !t.completed);
  const completed = filtered.filter(t => t.completed);

  return (
    <div className="page-fade">
      <div className="header-flex">
        <h1 className="title">Tasks</h1>
        <div className="header-actions">
          <button className="action-circle" onClick={() => setShowSearch(!showSearch)}><Search size={20}/></button>
          <button className="action-circle primary-bg" onClick={() => setIsModalOpen(true)}><Plus size={20}/></button>
        </div>
      </div>

      {showSearch && (
        <div className="search-overlay animate-expand">
          <div className="search-input-box">
            <Search size={18} />
            <input placeholder="Find a task..." value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} autoFocus />
            <X size={18} className="close-icon" onClick={() => {setSearchTerm(''); setShowSearch(false)}} />
          </div>
        </div>
      )}

      <div className="task-scroll-area">
        <h3 className="section-label">Pending ({pending.length})</h3>
        {pending.map(t => <TaskItem key={t.id} t={t} tasks={tasks} setTasks={setTasks} />)}
        
        {completed.length > 0 && (
          <>
            <h3 className="section-label completed-label">Completed ({completed.length})</h3>
            {completed.map(t => <TaskItem key={t.id} t={t} tasks={tasks} setTasks={setTasks} />)}
          </>
        )}
      </div>

      {isModalOpen && (
        <div className="modal-overlay animate-fade-in">
          <div className="glass-modal animate-slide-up">
            <div className="modal-header">
              <h2>Add Task</h2>
              <X onClick={() => setIsModalOpen(false)} className="cursor-p" />
            </div>
            <input className="modal-input" placeholder="Task description..." value={input} onChange={e => setInput(e.target.value)} />
            <div className="picker-grid">
              <div><label>Date</label><input type="date" value={date} onChange={e => setDate(e.target.value)} /></div>
              <div><label>Time</label><input type="time" value={time} onChange={e => setTime(e.target.value)} /></div>
            </div>
            <label className="mt-10">Link (Optional)</label>
            <input className="modal-input small" placeholder="https://..." value={link} onChange={e => setLink(e.target.value)} />
            <button className="confirm-btn" onClick={addTask}>Create Task</button>
          </div>
        </div>
      )}
    </div>
  );
};

const TaskItem = ({ t, tasks, setTasks }) => (
  <div className={`task-card animate-slide-in ${t.completed ? 'done' : ''}`} onClick={() => {
    setTasks(tasks.map(x => x.id === t.id ? {...x, completed: !x.completed} : x))
  }}>
    <div className="t-content">
      {t.completed ? <CheckCircle2 color="#10b981" /> : <Circle color="#94a3b8" />}
      <div className="t-info">
        <p className="t-text">{t.text}</p>
        <div className="t-tags">
          <span className="tag-date"><Calendar size={10}/> {t.date}</span>
          {t.time && <span className="tag-time"><Clock size={10}/> {t.time}</span>}
        </div>
      </div>
    </div>
    <div className="t-actions">
      {t.link && <a href={t.link} target="_blank" rel="noreferrer" onClick={e => e.stopPropagation()}><ExternalLink size={16}/></a>}
      <Trash2 size={16} className="del-btn" onClick={(e) => {e.stopPropagation(); setTasks(tasks.filter(x => x.id !== t.id))}} />
    </div>
  </div>
);

export default TasksPage;